import styled, { css } from 'styled-components';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';
import { NAV_HEIGHT_DESKTOP, NAV_HEIGHT_MOBILE } from 'packages/smart-home-support/components/Header/constants';

interface Margins {
  top?: boolean;
  bottom?: boolean;
  left?: boolean;
  right?: boolean;
}

export interface SectionFrameProps {
  mobile: Margins;
  tablet?: Margins;
  desktop: Margins;
}

const MARGIN_MOBILE = 12;
const MARGIN_MOBILE_BIG = 15;
const MARGIN_TABLET = 20;
const MARGIN_DESKTOP = 30;

const getDynamicMargin = (side: boolean | undefined, margin: number) => {
  if (side) {
    return `${margin / 2}px`;
  }

  return `${margin}px`;
};

const getMargins = (props: Margins, margin: number) => {
  return `
    margin-top: ${getDynamicMargin(props.top, margin)};
    margin-bottom: ${getDynamicMargin(props.bottom, margin)};
    margin-right: ${getDynamicMargin(props.right, margin)};
    margin-left: ${getDynamicMargin(props.left, margin)};
  `;
};

export const SectionFrameStyles = css`
  ${(props: SectionFrameProps) => getMargins(props.mobile, MARGIN_MOBILE)}

  @media ${BREAK_POINTS.mobileBig} {
    ${(props: SectionFrameProps) => getMargins(props.mobile, MARGIN_MOBILE_BIG)}
  }

  @media ${BREAK_POINTS.tablet} {
    min-height: 400px;
    margin: 15px 0px 15px 0px;
  }

  @media ${BREAK_POINTS.desktop} {
    height: calc(100vh - ${NAV_HEIGHT_DESKTOP}px - ${2 * MARGIN_DESKTOP}px);
    margin: 15px 0px 15px 0px;
  }
`;

const SectionFrame = styled.div`
  ${SectionFrameStyles}
  max-height: 1200px;
`;

export default SectionFrame;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/homepage/components/SectionFrame.tsx